$_vikon(() => {
    $_vikon('.collapsible').click((event) => {
        event.preventDefault();
        const $target = $_vikon(event.target);
        const collapseBlockId = $target.attr('href');
        $_vikon(`${collapseBlockId}.collapse`).toggleClass('show');
    });
});
